import { BreakpointObserver } from '@angular/cdk/layout';
import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  Input,
  OnDestroy,
  OnInit,
  inject,
} from '@angular/core';
import { downloadPdf } from '@app/helpers/webform';
import { DataService } from '@app/services/data.service';
import { TextsService } from '@app/services/texts.service';
import { KeyValue, WebformService } from '@app/services/webform.service';
import { debounceTime, Subscription } from 'rxjs';

@Component({
  standalone: false,
  selector: 'webform-confirmation',
  templateUrl: './confirmation.component.html',
  styleUrls: ['./confirmation.component.scss'],
})
export class ConfirmationComponent implements AfterViewInit, OnInit, OnDestroy {
  @Input() settings!: KeyValue;
  calculator!: KeyValue;
  teasers: any[] = [];
  breakpointSub!: Subscription;

  readonly #webform = inject(WebformService);
  readonly #texts = inject(TextsService);
  readonly #data = inject(DataService);
  readonly #cdr = inject(ChangeDetectorRef);
  readonly #breakpointObserver = inject(BreakpointObserver);

  constructor() {
    this.#webform.calculatorElement.subscribe((val: KeyValue) => (this.calculator = val));
  }

  async ngOnInit(): Promise<void> {
    const list: string[] = this.settings.confirmation_teasers_list?.split(',');
    if (this.settings.confirmation_teasers_list !== '' && list?.length) {
      this.teasers = await this.#data.getTeaserList(list);

      this.teasers.sort((a, b) => {
        return list.indexOf(a.id) - list.indexOf(b.id);
      });

      this.#cdr.detectChanges();
    }

    this.breakpointSub = this.#breakpointObserver
      .observe([
        '(max-width: 709px)',
        '(min-width: 710px)',
        '(min-width: 1080px)',
        '(min-width: 1650px)',
      ])
      .pipe(debounceTime(100))
      .subscribe(() => {
        this.#cdr.detectChanges();
      });
  }

  ngOnDestroy(): void {
    if (this.breakpointSub) this.breakpointSub.unsubscribe();
  }

  ngAfterViewInit(): void {
    // reset stored data to have a clean session on next visit
    this.#webform.resetLocalStorage();
  }

  get hasNextSteps(): boolean {
    return (
      this.settings.confirmation_steps_title ||
      this.settings.confirmation_steps_lead ||
      this.settings.confirmation_steps?.length
    );
  }

  async download(): Promise<void> {
    const fileName: string = await this.#texts.getText(
      `application_download_${this.calculator['#plugin']}`,
      'primcalc',
      'antrag-standart.pdf'
    );
    downloadPdf(this.settings.pdf_blob, fileName || 'download', false);
  }
}
